import { create } from 'zustand'

export type Section =
  | 'overview'
  | 'how-it-works'
  | 'services'
  | 'why-findex'
  | 'reviews'
  | 'articles'
  | 'events'

interface ThemeStore {
  backgroundColor: string | null | undefined
  isMobileFormVisible: boolean
  activeSection: Section | 'get-started' | undefined
}
export const useThemeStore = create<ThemeStore>(() => ({
  backgroundColor: null,
  isMobileFormVisible: false,
  activeSection: undefined,
}))
